module.exports = __webpack_public_path__ + "static/Ciutadella-Medium-0f3639caf9d1a6aae2385ad72b1a0b83.woff";